export const libZhTranslations = {
  home: 'é¦é¡µ',
  login: {
    title: 'ç»å½å°å®å¾½æ·±è¿ª',
    login: 'ç»å½',
  },
  register: 'æ³¨å',
  resetPwd: {
    resetPwd: 'ä¿®æ¹å¯ç ',
  },
  ithinkdt: 'æ·±è¿ª',
  projectName: 'å®å¾½æ·±è¿ªç§æ',
  topSearchPh: 'ç«åæç´¢',
  language: 'è¯­è¨',
  personalCenter: 'ä¸ªäººä¸­å¿',
  setUp: 'è®¾ç½®',
  logOut: 'éåºç»å½',
  backPage: 'è¿åé¦é¡µ',
  returnPage: 'è¿åä¸ä¸é¡µ',
  loadingData: 'æ­£å¨å è½½æ°æ®...',
  pleaseChoose: 'è¯·éæ©',
  inprocessinQuiry: 'æ­£å¨æ¥è¯¢ä¸­...',
  noData: 'ææ æ°æ®',
  nomatchingResult: 'æ å¹éç»æ',
  pleaseInputContent: 'è¯·è¾å¥æç´¢åå®¹',
  generalManagement: 'éç¨ä»£ç åç±»ç®¡ç',
  universalManagement: 'éç¨ä»£ç å¼ç®¡ç',
  normal: 'æ­£å¸¸',
  abnormal: 'å¼å¸¸',
  dormancy: 'ä¼ç ',

  operations: {
    operation: 'æä½',
    sliding: {
      open: 'å¼',
      close: 'å³',
    },
    add: {
      add: 'æ°å¢',
      succ: 'æ°å¢æåï¼',
    },
    edit: {
      edit: 'ç¼è¾',
      succ: 'ä¿å­æåï¼',
      editSearch: 'ç¼è¾æç´¢é¡¹',
      editHeader: 'ç¼è¾è¡¨å¤´',
    },
    view: 'æ¥ç',
    roleSetting: 'ç¨æ·è§è²éç½®',
    ok: 'ç¡®è®¤',
    save: 'ä¿å­',
    delete: {
      delete: 'å é¤',
      confirm: 'æ¨ç¡®è®¤è¦å é¤{{value}}åï¼',
      checkEmpty: 'è¯·è³å°éæ©ä¸æ¡è¦å é¤çæ°æ®ï¼',
      succ: 'å é¤æåï¼',
    },

    fill: {
      mustFill: 'è¯·å¡«åå¿å¡«é¡¹!',
    },

    next: {
      next: 'ä¸ä¸æ­¥',
      finish: 'å®æ',
    },
    lock: {
      lock: 'éå®',
      confirm: 'æ¨ç¡®è®¤è¦éå®åï¼',
      succ: 'éå®æåï¼',
    },
    publish: {
      publish: 'åå¸',
      succ: 'åå¸æå',
    },
    reset: {
      reset: 'éç½®',
      confirm: 'æ¨ç¡®è®¤è¦éç½®åï¼',
      succ: 'éç½®æåï¼',
    },
    confirm: {
      confirm: 'ç¡®å®',
    },
    cancel: {
      cancel: 'åæ¶',
      confirm: 'æ¨ç¡®è®¤è¦åæ¶åï¼',
      succ: 'åæ¶æåï¼',
    },
    close: {
      close: 'å³é­',
    },
    select: {
      select: 'éæ©',
      confirm: 'è¯·è³å°éæ©ä¸æ¡è¦æä½çæ°æ®ï¼',
    },
    search: 'æç´¢',
    searchControl: 'ææ æ­¤æç´¢æ§ä»¶ç±»å',
    fold: 'å±å¼',
    unfold: 'æ¶èµ·',
    checkAll: 'å¨é',
    refresh: 'å·æ°',
  },

  placeholder: {
    input: 'è¯·è¾å¥...',
    select: 'è¯·éæ©...',
  },

  list: {
    total: 'å½åå±{{value}}æ¡è®°å½',
  },

  chName: 'ä¸­æåç§°',
  enName: 'è±æåç§°',
  createDate: 'åå»ºæ¥æ',
  creator: 'åå»ºäºº',
  type: 'ç±»å',
  remark: 'æè¿°',
  message: 'æ¶æ¯',
  noControlType: 'ææ æ­¤æ§ä»¶ç±»å',
  required: 'è¯·è¾å¥{{value}}',
  yes: 'æ¯',
  no: 'å¦',
  password: 'å¯ç ',
  invitationCode: 'éè¯·ç ',

  week: {
    Sunday: 'ææå¤©',
    Monday: 'ææä¸',
    Tuesday: 'ææäº',
    Wednesday: 'ææä¸',
    Thursday: 'ææå',
    Friday: 'ææäº',
    Saturday: 'ææå­',
  },

  netTips: {
    netError0: 'ç½ç»å¼å¸¸ï¼è¯·æ£æ¥ååè¯ï¼',
    netError401: 'è¯·åç»å½åè®¿é®ï¼',
    netError403: 'æéä¸è¶³ï¼è¯·èç³»ç®¡çåååè¯ï¼',
    netError404: 'è¯·æ±å°åéè¯¯ï¼è¯·ç¡®è®¤ååè¯ï¼',
    netError505: 'æå¡å¨å¼å¸¸ï¼è¯·ç¨ååè¯ï¼',
    netError504: 'è¯·æ±è¶æ¶ï¼è¯·ç¨ååè¯ï¼',
    netWarn: 'æªå¯ç¥éè¯¯ï¼å¤§é¨åæ¯ç±äºåç«¯ä¸æ¯æCORSææ æéç½®å¼èµ·',
    error: 'è¯·æ±è¶æ¶ï¼',
  },

  fileUpload: {
    upload: 'ä¸ä¼ ',
    fileUpload: 'æä»¶ä¸ä¼ ',
    confirmUpload: 'ç¡®è®¤ä¸ä¼ ',
    cancel: 'åæ¶',
    clickArea: 'åå»ææå¨æä»¶å°è¯¥åºåä¸ä¼ ',
    supportDocuments: 'æ¯æåä¸ªææ¹éæä»¶ä¸ä¼ ,ä¸¥ç¦ä¸ä¼ å¬å¸æ°æ®æå¶ä»ç¸å³æä»¶',
    uploadSuccess: 'ä¸ä¼ æåï¼',
    uploadError: 'ä¸ä¼ å¤±è´¥ï¼æªç¥éè¯¯',
  },

  pagesTab: {
    myCollection: 'æçæ¶è',
    noCollection: 'ææ æ¶è',
  },
  settingDrawer: {
    systemSetup: 'ç³»ç»è®¾ç½®',
    styleSettings: 'æ´ä½é£æ ¼è®¾ç½®',
    themeColor: 'ä¸»é¢è²',
    navigationMode: 'å¯¼èªæ¨¡å¼',
    contentAreaWidth: 'åå®¹åºåå®½åº¦',
    fixedHeader: 'åºå® Header',
    hideWhileSliding: 'ä¸æ»æ¶éè Header',
    themeCompiled: 'æ­£å¨ç¼è¯ä¸»é¢ï¼',
    successfulCompilation: 'ç¼è¯æåï¼',
    styles: {
      darkStyle: 'æè²èåé£æ ¼',
      brightStyle: 'äº®è²èåé£æ ¼',
    },
    colors: {
      blue: 'èè²',
      red: 'çº¢è²',
      volcano: 'ç«å±±çº¢',
      croci: 'æ©é»è²',
      cyan: 'éè²',
      green: 'ç»¿è²',
      geekblue: 'æ·±èè²',
      purple: 'ç´«è²',
    },
    navModes: {
      slidMenu: 'ä¾§è¾¹èåå¸å±',
      topMenu: 'é¡¶é¨èåå¸å±',
    },
    contentWidths: {
      streaming: 'æµå¼',
      fixedWidth: 'å®å®½',
    },
  },

  route: {
    baseData: {
      codeType: 'éç¨ä»£ç åç±»ç®¡ç',
      codeValue: 'éç¨ä»£ç å¼ç®¡ç',
    },
    system: {
      userManagement: 'ç¨æ·ç®¡ç',
      authorityManagement: 'æéç®¡ç',
      roleManagement: 'è§è²ç®¡ç',
      departManagement: 'é¨é¨ç®¡ç',
      systemParam: 'ç³»ç»åæ°',
      systemLog: 'ç³»ç»æ¥å¿',
      businessLog: 'ä¸å¡æ¥å¿',
      tenant: 'ç§æ·ç®¡ç',
      app: 'åºç¨ç®¡ç',
      resourcePackage: 'èµæºåç®¡ç',
    },
  },
  defaultValue: {
    item: 'é¡¹',
  },
  account: {
    exchangeSuccess: 'åæ¢æå',
    settingSuccess: 'è®¾ç½®æå',
    exchangeTitle: 'åæ¢è´¦å·',
    settingDefault: 'è®¾ç½®é»è®¤',
  },
  bind: {
    bindSucc: 'ç»å®æå',
    unbindSucc: 'è§£ç»æå',
    bindTitle: 'ç»å®è´¦æ·',
    bind: 'ç»å®',
    account: 'è´¦æ·',
    hasBind: 'å·²ç»å®',
    noBind: 'æªç»å®',
    hasBindSucc: 'å·²æåç»å®,æ¨å¯ä»¥ä½¿ç¨',
    noBindSucc: 'ç»å®åï¼å¯ä»¥ä½¿ç¨',
    accountLogin: 'è´¦æ·ç»å½',
    unbind: 'è§£é¤ç»å®',
    unbindResult: 'è§£é¤ç»å®ä¼å½±åä½¿ç¨',
    bindResult: 'æ«æäºç»´ç ï¼è¿è¡',
  },
  default: {
    mobileNo: 'ææºå·',
    getVerificationCode: 'è·åéªè¯ç ',
    readAndAgree: 'æå·²éè¯»å¹¶åæ',
    notesForSupplier: 'ãä¾åºåæ³¨æäºé¡¹ã',
    name: 'è´¦å·',
    register: 'è´¦å·æ³¨å',
    clickToOpration: 'å³å»è¿è¡æä½',
    navigator: {
      total: 'å±',
      pieceData: 'æ¡æ°æ®,',
      currentDisplay: 'å½åæ¾ç¤º',
      pieces: 'æ¡',
    },
    configurationHeader: 'éç½®è¡¨å¤´',
    request: {
      error: 'è¯·æ±æéå¤±è´¥ï¼è¯·å¤çå¤±è´¥çæåµï¼',
      notSetting: 'ç¨æ·å°æªå¯¹æ­¤ç«ç¹ä½åºéç¥æéè®¾ç½®ï¼',
    },
    message: {
      notice: 'éç¥',
      clearNotice: 'æ¸ç©ºéç¥',
      emptyNotice: 'ä½ å·²æ¥çææéç¥',
      information: 'æ¶æ¯',
      clearInformation: 'æ¸ç©ºæ¶æ¯',
      emptyInformation: 'æ¨å·²è¯»å®æææ¶æ¯',
      dealt: 'å¾å',
      clearDealt: 'æ¸ç©ºå¾å',
      emptyDealt: 'ä½ å·²å®æææå¾å',
    },
    route: {
      error: 'å½åè¦å³é­çè·¯å¾ä¸å­å¨ï¼è¯·æ£æ¥ååè¯ï¼',
    },
    operations: {
      open: 'å±å¼',
      close: 'æ¶èµ·',
    },
  },

  dictType: {
    dictType: 'åç±»ç¼ç ',
    parentType: 'ç¶åç±»ç¼ç ',
    enterDictType: 'è¯·è¾å¥åç±»ç¼ç !',
    dictTypeExist: 'åç±»ç¼ç å·²å­å¨!',
    enterChName: 'è¯·è¾å¥ä¸­æåç§°!',
  },

  userManagement: {
    userName: 'ç¨æ·å',
    userNameTips: 'è¯·è¾å¥ç¨æ·å!',
    name: 'å§å',
    nameTips: 'è¯·è¾å¥å§å!',
    email: 'é®ç®±',
    department: 'é¨é¨',
    unlock: 'å¯ç¨',
    lock: 'ç¦ç¨',
    mobile: 'ææº',
    mobileTips: 'è¯·è¾å¥ææºå·',
    accountTips: 'è¯·è¾å¥æ­£ç¡®çè´¦å·',
    mobileTypeTips: 'è¯·è¾å¥æ­£ç¡®çææºæ ¼å¼',
    phone: 'çµè¯',
    passwordTips: 'è¯·è¾å¥è³å°{{value}}ä½æ°å¯ç ',
    passwordTip: 'è¯·è¾å¥å¯ç ',
    oldPasswordTips: 'è¯·è¾å¥æ¨çæ§å¯ç ',
    newPasswordTips: 'è¯·è¾å¥æ¨çæ°å¯ç ',
    passwordTypeTips: 'è¯·è¾å¥æ­£ç¡®çå¯ç !',
    confirmPassword: 'ç¡®è®¤å¯ç ',
    changePasswordSuccess: 'å¯ç ä¿®æ¹æå',
    confirmPasswordTips: 'è¯·åæ¬¡è¾å¥å¯ç ',
    passwordDiff: 'ä¸¤æ¬¡è¾å¥çå¯ç ä¸ä¸è´',
    invitationCodeTips: 'è¯·è¾å¥éè¯·ç !',
    selectDepartment: 'è¯·éæ©é¨é¨',
    emailTips: 'è¯·è¾å¥é®ç®±å°å',
    emailTypeTips: 'è¯·è¾å¥æ­£ç¡®çé®ç®±æ ¼å¼',
    phoneTips: 'è¯·è¾å¥çµè¯å·ç ',
    lockWarning: 'å¯¹ä¸èµ·ï¼æ¨æ²¡æéå®ç¨æ·çæé',
    unlockWarning: 'å¯¹ä¸èµ·ï¼æ¨æ²¡æè§£éç¨æ·çæé',
    unlockConfirm: 'æ¨ç¡®å®è¦è§£éè¯¥ç¨æ·åï¼',
    lockConfirm: 'æ¨ç¡®å®è¦éå®è¯¥ç¨æ·åï¼',
    resetPassword: 'éç½®å¯ç ',
    address: 'å°å',
    addressTips: 'è¯·è¾å¥å°å',
    remark: 'å¤æ³¨',
    remarkTips: 'è¯·è¾å¥å¤æ³¨',
    verificationCodeTips: 'è¯·è¾å¥éªè¯ç ',
    findTenants: 'ç§æ·æ¥ç',
    notBelongToTenant: 'è¯¥ç¨æ·ä¸å±äºä»»ä½ç§æ·',
    isPlatformUser: 'å¹³å°ç¨æ·',
    platformUserTips: 'åå»ºç§æ·ç¨æ·æ¶ä¸å¾é',
  },

  labelManagement: {
    oldPassword: 'åå¯ç ',
    newPassword: 'æ°å¯ç ',
  },

  systemLog: {
    startEndDate: 'å¼å§ç»ææ¥æ',
    logLevel: 'æ¥å¿çº§å«',
    operater: 'æä½äºº',
    logMessage: 'æ¶æ¯åå®¹',
    logTime: 'æ¥å¿æ¶é´',
    clientIp: 'å®¢æ·ç«¯IP',
  },

  businessLog: {
    moduleName: 'æ¨¡å',
    operation: 'æä½',
  },

  systemParameter: {
    maxLength: 'è¯·è¾å¥é¿åº¦å°äº{{value}}çå¼',
    maxValue: 'è¯·è¾å¥å°äº{{value}}çå¼',
    reload: 'éæ°è½½å¥',
  },

  roleManagement: {
    role: 'è§è²',
    rightSetting: 'æéè®¾ç½®',
    roleRights: 'è§è²æé',
    roleName: 'è§è²å',
    roleDesc: 'è§è²æè¿°',
    roleNamePlaceholder: 'è¯·è¾å¥è§è²å',
    roleDescPlaceholder: 'è¯·è¾å¥è§è²æè¿°',
    configPortal: 'portalç»ä»¶è®¾ç½®',
    choosePortalComponentError: 'è¯·è³å°éæ©ä¸ä¸ªportalç»ä»¶ï¼',
  },

  dictCode: {
    dictType: 'åç±»ç¼ç ',
    dictKey: 'éç¨ä»£ç ',
    enterDictType: 'è¯·è¾å¥åç±»ç¼ç !',
    dictTypeExist: 'åç±»ç¼ç å·²å­å¨!',
    enterChName: 'è¯·è¾å¥ä¸­æåç§°!',
    tenant: 'ç§æ·',
    copy: 'å¤å¶',
  },
  department: {
    departmentName: 'é¨é¨åç§°',
    departmentDesc: 'é¨é¨æè¿°',
    departmentOrder: 'é¨é¨æåº',
    departmentType: 'é¨é¨ç±»å',
    enterDepartmentName: 'è¯·è¾å¥é¨é¨åç§°!',
    enterDepartmentDesc: 'è¯·è¾å¥é¨é¨æè¿°!',
  },
  authority: {
    moduleKbn: 'æéç±»å',
    parentId: 'ç¶æ¨¡åç¼å·',
    asMenu: 'æ¯å¦èå',
    innerType: 'InnerType',
    moduleId: 'æµæ°´å·',
    moduleName: 'åç§°',
    moduleLevel: 'çº§å«',
    moduleOrder: 'é¡ºåº',
    css: 'å¾æ æ ·å¼',
    asDashboard: 'é¦é¡µå¾æ ',
    asShortcut: 'å¿«æ·æ¹å¼',
    asAccess: 'å¨è§è²ä¸­æ¾ç¤º',
    dashboardColor: 'èæ¯',
    action: 'ç»é¢URL',
    preActions: 'æéURL',
    enterName: 'è¯·è¾å¥åç§°',
    appId: 'åºç¨',
  },
  appManagement: {
    appId: 'åºç¨ç¼å·',
    appIdTips: 'è¯·è¾å¥åºç¨ç¼å·',
    appName: 'åºç¨åç§°',
    appNameTips: 'è¯·è¾å¥åºç¨åç§°',
    onlineDate: 'ä¸çº¿æ¥æ',
    onlineDateTips: 'è¯·éæ©ä¸çº¿æ¥æ',
    director: 'è´è´£äºº',
    directorTips: 'è¯·è¾å¥è´è´£äºº',
    version: 'å½åçæ¬',
    versionTips: 'è¯·è¾å¥å½åçæ¬å·',
    versionDate: 'çæ¬ä¸çº¿æ¥æ',
    versionDateTips: 'è¯·éæ©å½åçæ¬ä¸çº¿æ¥æ',
    status: 'åºç¨ç¶æ',
    on: 'è§£é',
    off: 'éå®',
    turnOnConfirm: 'æ¨ç¡®å®è¦è§£éè¯¥åºç¨åï¼',
    turnOffConfirm: 'æ¨ç¡®å®è¦éå®è¯¥åºç¨åï¼',
    app: 'åºç¨',
    viewApp: 'æ¥çåºç¨',
    addApp: 'æ°å¢åºç¨',
    delApp: 'å é¤åºç¨',
    viewTenant: 'ç§æ·æ¥ç',
    chooseDelApp: 'è¯·éæ©éè¦å é¤çåºç¨',
  },
  tenantManagement: {
    tenantName: 'ç§æ·åç§°',
    contactor: 'èç³»äºº',
    userMax: 'æå¤§ç¨æ·æ°',
    endDate: 'å°ææ¶é´',
    status: 'ç§æ·ç¶æ',
    tenantNameTips: 'è¯·è¾å¥ç§æ·å!',
    contactorTips: 'è¯·è¾å¥èç³»äºº',
    logo: 'ç§æ·logo',
    logoTips: 'è¯·è¾å¥ç§æ·å°å',
    domain: 'ç§æ·åå',
    domainTips: 'è¯·è¾å¥ç§æ·åå(æ¯æå­æ¯ãæ°å­åä¸åçº¿)',
    companyImg: 'å¬å¸å¾ç',
    slogan: 'ç§æ·å£å·',
    sloganTips: 'è¯·è¾å¥ç§æ·å£å·',
    contactorEmailRequire: 'è¯·è¾å¥èç³»äººé®ç®±',
    contactorEmailError: 'é®ç®±æ ¼å¼ä¸æ­£ç¡®ï¼',
    contactorphoneTips: 'è¯·è¾å¥èç³»äººçµè¯å·ç ',
    contactormobileTips: 'è¯·è¾å¥èç³»äººææºå·',
    contactormobileError: 'ææºå·ä¸æ­£ç¡®',
    userMaxTips: 'è¯·è¾å¥æå¤§ç§æ·æ°é',
    userMaxError: 'æå¤§ç¨æ·æ°åªè½æ¯æ­£æ´æ°',
    endDateTips: 'è¯·è¾å¥å°ææ¶é´',
    unlockConfirm: 'æ¨ç¡®å®è¦è§£éè¯¥ç§æ·åï¼',
    lockConfirm: 'æ¨ç¡®å®è¦éå®è¯¥ç§æ·åï¼',
    lock: 'éå®',
    normal: 'è§£é',
    adminUser: 'ç®¡çå',
    adminUserTips: 'è¯·éæ©ç§æ·ç®¡çå',
    findResource: 'èµæºåæ¥ç',
    delResource: 'èµæºåå é¤',
    insertResource: 'æ·»å èµæºå',
    resource: 'èµæºå',
    selectResource: 'è¯·éæ©èµæºå',
    appSetting: 'ç§æ·åºç¨æ¥ç',
    addTenantApp: 'æ°å¢ç§æ·åºç¨',
    selectApp: 'è¯·éæ©åºç¨',
    price: 'ä»·æ ¼(å)',
    app: 'åºç¨',
    priceTips: 'è¯·è¾å¥ä»·æ ¼',
    priceError: 'ä»·æ ¼åªè½æ¯æ°å­',
    appNoTenant: 'è¯¥åºç¨ææ ç§æ·',
    tenantNoApp: 'è¯¥ç§æ·ææ åºç¨',
    tenantNoResource: 'è¯¥ç§æ·ææ èµæºå',
  },
  resourceManege: {
    resourceName: 'èµæºååç§°',
    resourceNamePlaceHolder: 'è¯·è¾å¥èµæºååç§°',
    resourceDesc: 'èµæºåæè¿°',
    resourceDescPlaceHolder: 'è¯·è¾å¥èµæºåæè¿°',
    lockConfirm: 'æ¨ç¡®å®è¦éå®è¯¥èµæºååï¼',
    unlockConfirm: 'æ¨ç¡®å®è¦è§£éè¯¥èµæºååï¼',
    resourcePackRights: 'èµæºåæé',
    resourceFeature: 'è¯·éæ©èµæºååè½',
    notBelongToTenant: 'è¯¥èµæºåæ²¡æåéç»ä»»ä½ç§æ·',
    chooseDelResource: 'éæ©éè¦å é¤çèµæºå',
  },
  pcpTheme: {
    company: 'ä¸æµ·ææ¡¥',
    menus: {
      titles: {
        quickLook: 'å¿«éæ¥ç',
        feature: 'åè½',
      },
      names: {
        collect: 'æ¶è',
        allApps: 'å¨é¨åºç¨',
        launcher: 'å¯å¨å¨',
        bomMgmt: 'BOMç®¡ç',
        issueMgmt: 'é®é¢ç®¡ç',
      },
    },
    userPanel: {
      addFriend: 'æ·»å å¥½å',
      customerService: 'æçå®¢æ',
      logout: 'éåºç»å½',
    },
  },
  caa: {
    msg: {
      downloadFileFailed: 'æä»¶ä¸è½½å¤±è´¥',
      downloadFileError: 'æä»¶ä¸è½½éè¯¯',
      illegalParameters: 'éæ³çåæ°',
      getDocInSessionFailed: 'ä»å½åä¼è¯è·åææ¡£å¤±è´¥',
      getSessionFailed: 'è·åSessionå¤±è´¥',
      getDocPropFailed: 'è·åææ¡£å±æ§å¤±è´¥:{{value}}',
      fileNotExists: 'æä»¶ä¸å­å¨:{{value}}',
      uploadFailed: 'ä¸ä¼ å¤±è´¥',
      uploadInternalError: 'ä¸ä¼ å¤±è´¥ï¼åé¨éè¯¯ï¼',
      renameDocFailed: 'éå½åææ¡£{{value}}å¤±è´¥',
      paramError: 'åæ°æ ¼å¼éè¯¯ï¼ç¼ºå°[fileList]',
      updatePropFailed: 'æ´æ°é¶ä»¶å±æ§å¤±è´¥',
      updateExtendedPropFailed: 'æ´æ°é¶ä»¶æ©å±å±æ§å¤±è´¥',
      saveDocFailed: 'ä¿å­ææ¡£å¤±è´¥',
      updatePropException: 'æ´æ°é¶ä»¶å±æ§å¼å¸¸',
      fileNameCannotBeEmpty: 'æä»¶åç§°ä¸è½ä¸ºç©º',
      openDocFailed: 'æå¼ææ¡£{{value}}å¤±è´¥',
      openParentDocFailed: 'æå¼ç¶ææ¡£{{value}}å¤±è´¥',
      openParentRootDocFilaed: 'è·åç¶ææ¡£çæ ¹äº§åå¤±è´¥',
      instanceDocIsNull: 'å®ä¾ææ¡£{{value}}ä¸ºç©º',
      updateInstanceSaveFailed: 'æ´æ°å®ä¾ä¿å­ææ¡£å¤±è´¥',
      openChildDocFailed: 'æå¼å­ææ¡£[{{value}}]å¤±è´¥',
      childDocNotExists: 'å­ææ¡£[{{value}}]ä¸å­å¨',
      addInstanceFailed: 'æ·»å å®ä¾å¤±è´¥',
      addedInstanceIsNull: 'æ·»å å®ä¾ä¸ºç©º',
      childDocCannotBeNull: 'å­ä»¶ä¸è½ä¸ºç©º',
      removeInstanceFailed: 'ç§»é¤å®ä¾å¤±è´¥',
      updateInstanceFailed: 'æ´æ°å®ä¾å¤±è´¥',
      missingPartIdParam: 'ç¼ºå°é¶ä»¶IDåæ°',
      openOriginDocFailed: 'æå¼åææ¡£å¤±è´¥',
      originDocNotExists: 'åææ¡£ä¸å­å¨',
      settingPartNoRevisonFailed: 'è®¾ç½®é¶ä»¶å·ãçæ¬å·å¤±è´¥',
      createNewDocFailed: 'åå»ºæ°ææ¡£å¤±è´¥',
      openNewDocFailed: 'æå¼æ°ææ¡£å¤±è´¥',
      settingNewDocExtendedPropFailed: 'è®¾ç½®æ°ææ¡£æ©å±å±æ§å¤±è´¥',
      saveNewDocExtendedPropFailed: 'æ°ææ¡£æ©å±å±æ§ä¿å­å¤±è´¥',
      createNewProductFailed: 'åå»ºè£éä»¶å¤±è´¥',
      cannotAddYourselfAsChild: 'ä¸è½å°èªå·±æ·»å ä¸ºå®ä¾',
      selectedDocIsEmpty: 'æªéä¸­ä»»ä½ææ¡£',
      replaceProductFailed: 'æ¿æ¢å®ä¾[{{value}}]å¤±è´¥',
      anErrorOccurred: 'åçäºä½ç½®éè¯¯ï¼è¯·éè¯ã éè¯¯æ¶æ¯ï¼{{value}}',
      commandNotFound: 'æªç¥çæä»¤',
      aCircularReferenceFound: 'æ·»å çè£é{{value}}ä¸­åç°å¾ªç¯å¼ç¨',
      diskFreeSpaceOut: 'å½åç£çå¯ç¨ç©ºé´ä¸è¶³ï¼å·²ä½äº {{value}} MB',
      bomConvertFailed: 'åæ°éè¯¯ï¼æ æ³è½¬æ¢ä¸ºBOM',
      newDocumentFailed: 'æ°ææ¡£åå»ºå¤±è´¥',
      assembleProductFailed: 'äº§åè£éå¤±è´¥',
      addExternalComponentFailed: 'ç»ä»¶{{value}}æ·»å å¤±è´¥',
      canNotContainChinese: 'æä»¶åç§°{{value}}ä¸è½åå«ä¸­æ',
      closeDocumentFailed: 'å³é­ææ¡£[{{value}}]å¤±è´¥',
      saveDocumentFailed: 'ä¿å­ææ¡£[{{value}}]å¤±è´¥',
      getInstPrdPropFailed: 'ä»äº§åä¸­è·åå®ä¾å¤±è´¥, å®ä¾åç§°ï¼{{value}}',
      getInstDocFailed: 'è·åå®ä¾ææ¡£å¤±è´¥, å®ä¾åç§°ï¼{{value}}',
      unSupportedFileType: 'ä¸æ¯æçææ¡£ç±»å{{value}}',
      compareBomFailed: 'BOM å¯¹æ¯åçéè¯¯',
      shapeCodecanNotContainChinese: 'åå½¢æ¹æ¡ï¼{{value}}ä¸è½åå«ä¸­æ',
      loginWasExpired: 'ç»å½å·²è¿ææç¼ºå°Tokenåæ°',
      getProductBomUnloadErr: 'æªæ¾å°ä»¥ä¸åè¡¨ä¸­çæä»¶ï¼æèè¿äºæä»¶åå«æ´»å¨ææ¡£çéè¯¯ä¿¡æ¯ã{{value}}',
      getFileJsonUrlNotFound: 'æªéç½®[getFileJsonUrl]åæ°',
      foundComponentErr: 'åç°ä»¥ä¸åè¡¨ä¸­çæä»¶ä½¿ç¨äºComponentï¼è¯·ä½¿ç¨\"PCP\"->\"Check\"è¿è¡è½¬æ¢ã\n{{value}}',
      dynAssmblyFailed: 'å¨æè£éåçéè¯¯ï¼è¯·éè¯',
      downloadFileEmpty: 'ä¸è½½çæä»¶{{value}}åå®¹ä¸ºç©ºï¼è¯·ç¡®è®¤æ¨çå¯å¨å¨éç½®æ¯å¦æ­£ç¡®ã',
      windowSwitching: 'å½åæ¿æ´»çªå£å·²åæ¢ï¼è¯·åæ¢å°ä»¥ä¸ææ¡£ççªå£.{{value}}'
    },
  },
};
